import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useCanEditShipmentItems } from './hooks/use-can-edit-shipment-items';
import { useModal } from '../../../../../hooks/use-modal';
import { useSalesOrderIdContext } from '../../../../context/sales-order-id-context-provider';
import { EditItemsModal } from '../../edit-items-modal/edit-items-modal';
import { ADD_EDIT_SHIPMENT_ITEMS_ACTIONS, useTrackAddEditItemsShipmentAction } from '../../../hooks/use-track-add-edit-items-action';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../../../../modals/order-details-modal/event-tracking/use-track-order-details-action';

import { addItemsButtonText } from './messages';

export const EmptyRowAddItemsButton = () => {
  const { open, close, isOpen } = useModal(false);
  const trackOrderDetailsAction = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.ADD_EDIT_SHIPMENT_ITEMS);
  const trackAddEditItemsShipmentOpen = useTrackAddEditItemsShipmentAction(ADD_EDIT_SHIPMENT_ITEMS_ACTIONS.OPEN);
  const trackAddEditItemsShipmentClose = useTrackAddEditItemsShipmentAction(ADD_EDIT_SHIPMENT_ITEMS_ACTIONS.CLOSE);

  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();
  const { canEditShipmentItems: canAddItems, fulfillmentPlanHasAdditionalItems } = useCanEditShipmentItems(fulfillmentPlanId, salesOrderId);

  const onClick = useCallback(() => {
    open();
    trackOrderDetailsAction();
    trackAddEditItemsShipmentOpen({
      fulfillmentPlanId,
      hasAdditionalItems: fulfillmentPlanHasAdditionalItems,
    });
  }, [fulfillmentPlanHasAdditionalItems, fulfillmentPlanId, open, trackAddEditItemsShipmentOpen, trackOrderDetailsAction]);
  const onClose = useCallback(() => {
    trackAddEditItemsShipmentClose({
      fulfillmentPlanId,
      hasAdditionalItems: fulfillmentPlanHasAdditionalItems,
    });
    close();
  }, [close, fulfillmentPlanId, trackAddEditItemsShipmentClose, fulfillmentPlanHasAdditionalItems]);

  if (!canAddItems) {
    return null;
  }

  return (
    <>
      <Button onClick={onClick} theme='primary'>
        <FormattedMessage {...addItemsButtonText} />
      </Button>
      {isOpen && <EditItemsModal fulfillmentPlanId={fulfillmentPlanId} onClose={onClose} salesOrderId={salesOrderId} />}
    </>
  );
};
